export enum RoutePaths {
  // Dashboard Route
  Dashboard = '/',

  // Assets Routes
  Assets = 'assets',
  AssetDetailProductInfomation = 'product-information',
  AssetDetailContacts = 'contacts',
  AssetDetailServiceContract = 'services',

  // Companies Routes
  Companies = 'companies',
  CompanyInformation = 'company-information',
  CompanyResource = 'company-resource',

  // Map Routes
  AssetsMap = 'map',
  AssetsMapVariant = 'map/:variant?',

  // Auth Routes
  UserLogin = 'auth',
  UserInfo = '/user',

  // Cookie Policy
  CookiePolicy = '/cookie-policy',

  // What is new
  WhatIsNew = '/what-is-new',

  // Generic Routes
  NotFound = '*',
  Details = ':id',
  Faq = '/faq',
  More = '/more',

  // Dealers
  Dealers = '/dealers',

  // Maintenance
  Maintenance = '/maintenance',

  // Third Party Software
  ThirdPartySoftware = '/third-party-software',

  // Fleet logout relay
  FleetLogoutRelay = '/fleet-logout',

  // external
  GiveFeedback = '#',
  OpenPWA = 'open',
}
